/**
 * Resolves after the current stack clears so other I/O, timers, and WebSocket
 * callbacks can run. Prefer this over long synchronous loops on the bridge path.
 */
export function yieldToEventLoop(): Promise<void> {
  return new Promise((resolve) => setImmediate(resolve));
}
